import { useMemo } from "react";
import { useFormContext } from "react-hook-form";
import { Box, Button, Stack } from "@mui/material";

import { FormSelectField } from "@covertree/ui";
import { BurglarAlarmValue } from "@covertree/new-business-graphql";
import {
  BurglarAlarmLabel,
  UnitLevelUnderwritingAnswers,
} from "@covertree/types";

import { QuestionModalProps } from "../underwritingQuestions";
import {
  mapBurglarAlarmLabel,
  mapQuestionOptionsToFormOptions,
} from "../../../mappings/underwritingQuestionsMaps";
import { UnderwritingQuestionsForm } from "../../../validatorsAndTypes/underwritingQuestions";

export function BurglarAlarmForm({
  questions,
  closeModal,
}: QuestionModalProps) {
  const { formState, control } = useFormContext<UnderwritingQuestionsForm>();
  const burglarAlarmOptions = useMemo(
    () =>
      mapQuestionOptionsToFormOptions<BurglarAlarmValue, BurglarAlarmLabel>(
        questions?.[UnitLevelUnderwritingAnswers.BurglarAlarm].options?.filter(
          (value) => value !== BurglarAlarmValue.No
        ) as BurglarAlarmValue[],
        mapBurglarAlarmLabel
      ),
    [questions]
  );

  return (
    <Stack spacing={4}>
      <Box>
        <FormSelectField
          control={control}
          name="burglarAlarmValue"
          id="kind-of-alarm"
          dataTestId="kind-of-alarm"
          options={burglarAlarmOptions}
          label="What kind of alarm do you have?"
        />
      </Box>
      <Box>
        <Button
          type="button"
          disabled={!formState.isValid}
          onClick={closeModal}>
          Save
        </Button>
      </Box>
    </Stack>
  );
}
